import { render, staticRenderFns } from "./routes_warehouse.vue?vue&type=template&id=31b58bf8&scoped=true&"
import script from "./routes_warehouse.vue?vue&type=script&lang=js&"
export * from "./routes_warehouse.vue?vue&type=script&lang=js&"
import style0 from "./routes_warehouse.vue?vue&type=style&index=0&id=31b58bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b58bf8",
  null
  
)

export default component.exports